import './Cart.scss';
import { useEffect } from 'react';
import { CartStepper } from './Stepper/Stepper';
import { useCartStore } from 'stores/Webshop/CartStore';
import { CartItem } from 'types/cart';
import { CartStepOne } from './CartStepOne/CartStepOne';
import { CartStepTwo } from './CartStepTwo/CartStepTwo';
import { CartStepThree } from './CartStepThree/CartStepThree';

export const Cart = () => {
  const addItemToCart = useCartStore((state) => state.addItemToCart);
  const setInitialized = useCartStore((state) => state.setInitialized);
  const initialized = useCartStore((state) => state.initialized);
  const activeStep = useCartStore((state) => state.activeStep);
  const setActiveStep = useCartStore((state) => state.setActiveStep);

  useEffect(() => {
    if (!initialized) {
      const cartFromLocalStorage = localStorage.getItem('cart');

      if (cartFromLocalStorage) {
        const parsedCart = JSON.parse(cartFromLocalStorage);
        parsedCart.items.forEach((item: CartItem) => addItemToCart(item));
      }
      setInitialized(true);
    }
  }, [initialized, addItemToCart, setInitialized]);

  return (
    <div className='cart-page'>
      <CartStepper activeStep={activeStep} handleActiveStep={setActiveStep} />
      {activeStep === 0 && <CartStepOne />}
      {activeStep === 1 && <CartStepTwo />}
      {activeStep === 2 && <CartStepThree />}
    </div>
  );
};
